import {Grid, Stack} from '@mui/material';
import {AppControlledInput} from 'components/form';
import React from 'react';
import {FieldsRendererProps} from '.';

interface RenderTextArearProps extends FieldsRendererProps {
    gridSize?: number;
}
export const RenderTextArea: React.FC<RenderTextArearProps> = ({field, control, baseFieldName, gridSize}) => {
    return (
        <Grid item md={gridSize} xs={12}>
            <Stack spacing={1}>
                <AppControlledInput
                    control={control}
                    label={field.title}
                    required={field.isRequired}
                    placeholder={field.placeHolder}
                    multiline
                    name={`${baseFieldName}.value`}
                    rows={4}
                />
            </Stack>
        </Grid>
    );
};

export default RenderTextArea;
